import React from 'react'
import { AxiosError } from 'axios'
import { appActions } from 'store/app'
import { authApi } from 'api/auth'
import { isSameTokenUser } from 'shared/utils/auth/isSameTokenUser'
import { showMessage } from 'shared/utils/showMessage'
import { getTelegramWebApp, loadTelegramWebApp } from 'shared/utils/telegram'
import { useAppDispatch } from './useReduxHooks'

export const useAuth = (): { isLoaded: boolean; isError: boolean } => {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const [isError, setIsError] = React.useState(false)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    // Мини-приложение Telegram знает, кто его открыл: меняем его подписанные
    // данные на токен сессии, чтобы продавец не входил заново при каждом запуске
    const loginByTelegram = async () => {
      await loadTelegramWebApp()
      const webApp = getTelegramWebApp()
      if (!webApp) return false

      try {
        const response = await authApi.loginTelegramWebApp(webApp.initData)
        dispatch(appActions.setToken(response.data))
        return true
      } catch {
        // Бот не подключён или аккаунт не подошёл — покажем обычный вход
        return false
      }
    }

    const checkAuth = async () => {
      try {
        // Кто открыл мини-приложение, решает Telegram, а не сохранённый токен:
        // после перепривязки бота к другому магазину в localStorage остаётся
        // сессия прежнего продавца и кабинет открывался бы от его имени
        if (await loginByTelegram()) return
        // Сессию держит httpOnly-кука, а не localStorage: Safari чистит
        // хранилище через 7 дней, кука остаётся — поэтому /refresh зовём всегда
        const response = await authApi.checkAuth()
        // Сессия могла обновиться под другим аккаунтом (вход на сайте в том же
        // браузере) — тогда выходим, а не подменяем пользователя молча
        if (!isSameTokenUser(response.data.access_token)) {
          showMessage('error', 'Сессия завершена', 'Войдите в аккаунт заново')
          return dispatch(appActions.logout())
        }
        dispatch(appActions.setToken(response.data))
      } catch (e) {
        const error = e as AxiosError
        if(error?.response?.status === 401 || error?.response?.status === 400 || error?.response?.status === 403) {
          return dispatch(appActions.logout())
        }
        setIsError(true)
      } finally {
        setIsLoaded(true)
      }
    }
    checkAuth()
  }, [])

  return { isLoaded, isError }
}
